import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchUserAllAssessments, getAllParticipantsOfAssessment } from '../../services/authService';
import { useAuth } from '../../context/AuthContext';
import ParticipantCard from './PartcipantCard';
import { decodeId } from '../../utills/idUtils';
import Logo from '../../assets/images/logo.png';
import pdfPreImg from '../../assets/images/pdf360.png'
import FancyLoader from '../../hooks/FancyLoder';

const PatcipantReport = ({ isGeneratingPdf, assessment_type }) => {
    const { encodedId } = useParams();
    const id = decodeId(encodedId)
    const { state } = useAuth();
    const { user } = state;

    const [participants, setParticipants] = useState([]);
    const [assessmentStatus, setAssessmentStatus] = useState(''); // Store the assessment status
    const [loadingParticipants, setLoadingParticipants] = useState(true);
    const [loadingAssessment, setLoadingAssessment] = useState(true);
    const [error, setError] = useState(null);
    const [useridArr, setUserIdarr] = useState(null);
    const [send, setSend] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");

    const userId = user?.user_id;

    useEffect(() => {
        if (!userId || !id) return;
        setUserIdarr(id);

        // Fetch participants
        const fetchParticipants = async () => {
            try {
                const participantResponse = await getAllParticipantsOfAssessment(id);
                ////console.log('Participants:', participantResponse.data);
                setParticipants(participantResponse.data);
            } catch (err) {
                setError(`Failed to fetch participants: ${err.message}`);
            } finally {
                setLoadingParticipants(false);
            }
        };

        // Fetch assessment details
        const fetchAssessmentDetails = async () => {
            try {
                const assessmentResponse = await fetchUserAllAssessments(userId);
                ////console.log('Assessment Details:', assessmentResponse.initiatorAssessments);
                const selectedAssessment = assessmentResponse.initiatorAssessments.find(
                    assessment => assessment.assessment_id === parseInt(id)
                );
                if (selectedAssessment) {
                    //console.log("selectedAssessment", selectedAssessment)
                    setAssessmentStatus(selectedAssessment);
                } else {
                    setError('Assessment not found');
                }
            } catch (err) {
                setError(`Failed to fetch assessment: ${err.message}`);
            } finally {
                setLoadingAssessment(false);
            }
        };

        fetchParticipants();
        fetchAssessmentDetails();
    }, [id, userId]);

    if (loadingParticipants || loadingAssessment) {
        return <FancyLoader />;
    }


    if (error) return <div>Error: {error}</div>;

    const pendingParticipants = participants.filter(p => p.status === 'Pending');
    const completedParticipants = participants.filter(p => p.status === 'Completed');

    const handleSuccessMessage = (message) => {
        setSuccessMsg(message);
        setTimeout(() => {
            setSend(false);
            setSuccessMsg('');
        }, 3000);
    };


    function capitalizeFirstLetter(name) {
        if (!name) return '';
        return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    }
    const handleSendReminder = () => {
        setConfirm(true);
        setTimeout(() => {
            setConfirm(false);
        }, 3000);
    };

    const handleConfirmSend = () => {
        ////console.log("Sending reminders...");
        setConfirm(true);
        setSend(true);
        setTimeout(() => {
            setConfirm(false);
        }, 3000);
    };

    const handleCancelSend = () => {
        setConfirm(false);
    };

    return (
        <div className="flex flex-col items-center lg:px-16 p-4">
            {isGeneratingPdf && (
                <img
                    src={pdfPreImg}
                    alt="preLogo_img"
                    className="w-full lg:mx-2 object-cover p-2 py-10 lg:py-20"
                    style={{
                        height: "100%", // Height of an A4 paper in pixels
                        maxWidth: "100%", // Ensure responsiveness
                        objectFit: "cover", // Ensures the image covers the entire container
                    }}
                />
            )}

            <div className=" py-2 lg:py-5 w-full bg-blue-600 text-white text-center rounded-tl-xl rounded-tr-xl ">
                <div className="flex  flex-row justify-between items-start lg:items-center gap-2 px-4 py-4 ">

                    {/* {isGeneratingPdf && (
                    <img
                        src={Logo}
                        alt="logo_img"
                        className="w-16 h-auto lg:w-auto lg:h-12 lg:mr-5"
                    />
                )} */}

                    <div className="text-left flex-1">
                        <span className="block text-lg lg:text-xl font-semibold text-white">
                            {assessment_type === "360" ? "Executive Presence 360° Feedback Report" : "Executive Presence Self-Assessment Report"}
                        </span>
                        <span className="block text-lg lg:text-xl font-semibold text-white">
                            For: {capitalizeFirstLetter(user.first_name)} {capitalizeFirstLetter(user.last_name)}
                        </span>
                    </div>


                    {/* <div className="text-center flex-1 ">
                        <span className="block text-lg lg:text-xl font-semibold text-white">
                            Started: {new Date(assessmentStatus.initiation_date).toLocaleDateString()}
                        </span>
                    </div>

                    <div className="text-center flex-1">
                        <span className="block text-lg lg:text-2xl font-bold text-white">
                            Result for {capitalizeFirstLetter(user.first_name)}
                        </span>
                    </div>

                    <div className="text-center flex-1">
                        <span className="block text-lg lg:text-xl font-semibold text-white">
                            Completed: {new Date(assessmentStatus.actual_completion_date).toLocaleDateString()}
                        </span>
                    </div> */}

                    <div className="flex flex-col items-end">
                        <span className="block text-lg lg:text-xl font-semibold text-white">
                            Started: {new Date(assessmentStatus.initiation_date).toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' })}
                        </span>
                        <span className="block text-lg lg:text-xl font-semibold text-white">
                            Completed: {new Date(assessmentStatus.actual_completion_date).toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' })}
                        </span>
                    </div>
                </div>

            </div>
            {assessmentStatus.assessment_type !== 'self' && isGeneratingPdf && (
                <>


                    <div className="bg-amber-50 p-6 mt-4 rounded-lg  w-11/12">
                        <h2 className="text-xl font-semibold mb-4" style={{ fontFamily: 'Helvetica' }}>Respondents - Complete</h2>
                        <div className="border-2 border-dashed border-purple-400 p-4">
                            <div className="flex flex-wrap justify-between">
                                {completedParticipants?.length}
                            </div>
                        </div>
                    </div>

                    <div className="bg-amber-50 p-6 mt-4 rounded-lg  w-11/12">
                        <h2 className="text-xl font-semibold mb-4" style={{ fontFamily: 'Helvetica' }}>Respondents - Did not Complete</h2>
                        <div className="border-2 border-dashed border-purple-400 p-4">
                            <div className="flex flex-wrap justify-between">
                                {pendingParticipants?.length}
                            </div>
                        </div>
                    </div>
                </>
            )}

            {assessmentStatus.assessment_type !== 'self' && !isGeneratingPdf && (
                <>


                    {/* Completed Participants */}
                    <div className="bg-green-50 p-6 mt-4 rounded-lg  w-full">
                        <h2 className="text-xl font-semibold mb-4" style={{ fontFamily: "Helvetica" }}
                        >Respondents - Completed</h2>
                        <div className="border-2 border-dashed border-purple-400 p-4">
                            <div className="flex flex-wrap justify-between" style={{ fontFamily: "Helvetica" }}
                            >
                                {completedParticipants.length > 0 ? (
                                    completedParticipants.map(participant => (
                                        <ParticipantCard key={participant.assessment_user_id} participant={participant} />
                                    ))
                                ) : (
                                    <div>No completed participants.</div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Pending Participants */}
                    {pendingParticipants.length > 0 && (
                        <div className="bg-amber-50 p-6 mt-4 rounded-lg  w-full">
                            <h2 className="text-xl font-semibold mb-4" style={{ fontFamily: "Helvetica" }}
                            >Respondents - Did not Complete</h2>
                            <div className="border-2 border-dashed border-purple-400 p-4">
                                <div className="flex flex-wrap justify-between">
                                    {pendingParticipants.map(participant => (
                                        <ParticipantCard key={participant.assessment_user_id} participant={participant} />
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}

                </>
            )}

        </div>
    );
};

export default PatcipantReport;
